import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

//MUI
import { Box } from '@mui/system';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { getUi, ifPageChange, setMobile, setPage } from 'state/reducers/ui.reducers';
import { useLocation, useNavigate } from 'react-router-dom';

const AssetsProvider = () => {
	const dispatch = useAppDispatch();
	const ui = useAppSelector(getUi);
	const ifToNavigate = useAppSelector(ifPageChange);
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 600) {
				if (!ui.isMobile) {
					dispatch(setMobile(true));
				}
			} else {
				if (ui.isMobile) {
					dispatch(setMobile(false));
				}
			}
		};
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [ui]);

	useEffect(() => {
		if (ifToNavigate && !ui.checkBeforeNavigate) {
			navigate(ui.to);
		}
	}, [ifToNavigate, ui.checkBeforeNavigate]);

	useEffect(() => {
		dispatch(setPage(location.pathname));
		window.scrollTo(0, 0);
	}, [location]);

	return <Fragment></Fragment>;
};
export default AssetsProvider;
